import { render, staticRenderFns } from "./ForexTransfer.vue?vue&type=template&id=3ea42af0&"
import script from "./ForexTransfer.vue?vue&type=script&lang=js&"
export * from "./ForexTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports